export default from './WelcomePage';



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/WelcomePage/index.js